module.exports = __webpack_public_path__ + "static/media/logo.39f776b9.svg";